import type { AutocompleteProps } from '@mui/material';
import { Autocomplete, TextField } from '@mui/material';
import type { FormikProps } from 'formik';

type Props<ID, T> = Omit<
  AutocompleteProps<string, false, false, false>,
  'renderInput'
> & {
  id: ID;
  formik: FormikProps<T>;
  label?: string;
};

export function FormikAutocomplete<
  ID extends string,
  T extends { [key in ID]?: string },
>(props: Props<ID, T>): JSX.Element {
  const { formik, label, ...autocompleteProps } = props;
  return (
    <Autocomplete<string, false, false, false>
      renderInput={(params) => (
        <TextField
          {...params}
          error={formik.touched[props.id] && Boolean(formik.errors[props.id])}
          helperText={formik.errors[props.id] as string}
          label={label}
        />
      )}
      {...autocompleteProps}
      disabled={formik.isSubmitting || props.disabled}
      onChange={(_, value) => formik.setFieldValue(props.id, value)}
      value={formik.values[props.id] ?? null}
    />
  );
}
